import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import { servicePayments } from "../servicePayments";

export const getRequirement = async (
  requirementId: string
): Promise<IRequirementResponse> => {
  const response = await servicePayments.get(`/requirement/${requirementId}`);
  return response.data;
};
